const PREP_PREFIX = "tih_prep_";

export function loadPrepProgress(eventId: number): string[] {
  if (typeof window === "undefined") return [];
  try {
    const raw = window.localStorage.getItem(`${PREP_PREFIX}${eventId}`);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as unknown;
    return Array.isArray(parsed) ? parsed.filter((x) => typeof x === "string") : [];
  } catch {
    return [];
  }
}

export function savePrepProgress(eventId: number, checkedIds: string[]): void {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(`${PREP_PREFIX}${eventId}`, JSON.stringify(checkedIds));
}
